<template>
  <div class="mainTitle">
    <span>{{ taskName }}</span>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import useTaskStore from "@/stores/modules/task";

const taskStore = useTaskStore();
const { taskName } = storeToRefs(taskStore);
</script>

<style lang="scss" scoped>
.mainTitle {
  flex-grow: 1;
  padding: 0 0 0 140px;
  text-align: center;
  color: #fff;
  font-size: 1.5rem;
  font-weight: 700;
  z-index: 2;
}
</style>
